'use strict';

var _ = require('lodash');
var React = require('react');
var ReactDOM = require('react-dom');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./style-guide.scss');

    var respimage = require('respimage');
    require('respimage/plugins/intrinsic-dimension/ri.intrinsic.js');
}

var Constants = require('../../constants');
var Forms = require('../../forms');
var Global = require('../../global');
var Components = require('../../components');

var DeviceImage = Global.DeviceImage;
var Select = Forms.Select;

// var picturefill = require('picturefill');
// picturefill.picturefill.setOptions({
//     addDimensions: true,
// });

var ResponsiveIdentification = (props) => {
    return (
        <div className='guide-segment guide-responsive'>
            <div className='desktop'>desktop</div>
            <div className='mobile'>mobile</div>
            <div className='mobile-portrait'>mobile portrait</div>
            <div className='mobile-landscape'>mobile landscape</div>
            <div className='mobile-landscape-lowres'>mobile landscape lowres</div>
        </div>
    );
};

var ResponsiveImages = React.createClass({
    // componentDidMount: function() {
    //     console.log(picturefill);
    //     this.forceUpdate();
    // },
    render: function() {
    var path = Constants.static + 'images/global/guide';
    var breaks = Constants.Breaks;
    // console.log(breaks);
    var desktopMediaQuery = `(min-width: ${breaks.MobilePortraitMax+1}px) and (orientation: portrait), ` +
                            `(min-width: ${breaks.MobileLandscapeMax+1}px) and (orientation: landscape)`;
    var mobileMediaQuery = `(max-width: ${breaks.MobilePortraitMax}px) and (orientation: portrait), ` +
                           `(max-width: ${breaks.MobileLandscapeMax}px) and (orientation: landscape)`;
// console.log(desktopMediaQuery);
// console.log(window.devicePixelRatio);
    return (
        <div>
            {/*
            <div className='guide-responsiveImages'>
                <picture>
                    
                        <source srcSet={`${path}/desktop/arrow.png 1x, ${path}/desktop/arrow@2x.png 2x`} media={desktopMediaQuery} />
                        <source srcSet={`${path}/mobile/arrow.png 1x, ${path}/mobile/arrow@2x.png 2x`} media={mobileMediaQuery} />
                    

                    <img srcSet={`${path}/desktop/logo.png 1x, ${path}/desktop/logo@2x.png 2x`} src={`${path}/desktop/invalid.png`} />
                </picture>
                
                <span className='guide-responsiveImages-reference' />
                <img className='guide-responsiveImages-refMobileImage' src={`${path}/desktop/arrow.png`} />
                <img className='guide-responsiveImages-refMobileImage' src={`${path}/mobile/arrow.png`} />
                <div className='guide-responsiveImages-reference' />
            </div>
            <div className='guide-responsiveImages' style={{ backgroundColor: 'black' }}>
                <picture>
                        <source srcSet={`${path}/desktop/logo.png 1x, ${path}/desktop/logo@2x.png 2x`} media={desktopMediaQuery} />
                        <source srcSet={`${path}/mobile/logo.png 1x, ${path}/mobile/logo@2x.png 2x`} media={mobileMediaQuery} />
                    <img srcSet={`${path}/desktop/logo.png 1x, ${path}/desktop/logo@2x.png 2x`} src={`${path}/desktop/logo.png`} />
                </picture>
            </div>
            */}
            <div className='guide-segment guide-responsiveImages' style={{ backgroundColor: 'black' }}>
                <DeviceImage src='global/guide/desktop/logo.png' alt='alt text' />
            </div>
        </div>
    );
},
});
//                <meta name="if-ie9" dangerouslySetInnerHTML={{ __html: '<!--[if IE 9]><video style="display: none;"><![endif]-->' }} />
//                <meta name="end-ie9" dangerouslySetInnerHTML={{ __html: '<!--[if IE 9]></video><![endif]-->' }} />

var BrandColors = (props) => {
    var brandColors = [[
        'grey1',
        'blue1',
        'grey2',
    ], [
        'blue2',
        'blue3',
        'blue4',
        'blue5',
    ], [
        'grey3',
        'grey4',
        'grey5',
        'grey6',
    ], [
        'orange',
    ]];
    var nameToColor = {
        blue1:  '#5da2ab',
        blue2:  '#17292b',
        blue3:  '#2f5156',
        blue4:  '#7db5bc',
        blue5:  '#bedadd',
        grey1:  '#25292d',
        grey2:  '#e8e4e6',
        grey3:  '#363c43',
        grey4:  '#6d737a',
        grey5:  '#afafaf',
        grey6:  '#dbdbdb',
        orange: '#ff9100',
    };
    return (
        <div className='guide-segment guide-brand'>
            {brandColors.map((colors, ix) => {
                return (
                    <div className='guide-brand-group' key={ix}>
                        {colors.map((c, ix) => {
                            return (
                                <div className={`guide-brand-swatch ${c}`} key={ix}>
                                    {c}
                                    <br /><br />
                                    {nameToColor[c]}
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
};

var Buttons = React.createClass({
    onClick: function() {
        alert('Click!');
    },
    render: function() {
        return (
            <div className='guide-segment guide-buttons'>
                <div className='guide-buttons-light'>
                    <Forms.Button onClick={this.onClick} label='Button'          theme='light' type='prev' />
                    <Forms.Button onClick={this.onClick} label='Link'            theme='light' type='next' link='/' external={true} />
                    <Forms.Button onClick={this.onClick} label='Inactive button' theme='light' type='prev' inactive={true} />
                    <Forms.Button onClick={this.onClick} label='Inactive link'   theme='light' type='next' inactive={true} link='/' external={true} />
                </div>
                <div className='guide-buttons-light'>
                    <Forms.Button onClick={this.onClick} label='Neutral button' theme='light' type='neutral' />
                    <Forms.Button onClick={this.onClick} label='Submit button' theme='light' type='submit' />
                </div>
                <div className='guide-buttons-dark'>
                    <Forms.Button onClick={this.onClick} label='Button'          theme='dark' type='prev' />
                    <Forms.Button onClick={this.onClick} label='Link'            theme='dark' type='next' link='/' external={true} />
                    <Forms.Button onClick={this.onClick} label='Inactive button' theme='dark' type='prev' inactive={true} />
                    <Forms.Button onClick={this.onClick} label='Inactive link'   theme='dark' type='next' inactive={true} link='/' external={true} />
                </div>
            </div>
        );
    },
});

var FormsTest = React.createClass({
    render: function() {
        return (
            <div className='guide-segment guide-forms'>

                <div className='form-field'>
                    <Forms.Input label='FIRST NAME' keyname='firstname' placeholder='FIRST NAME' ref='firstname' />
                </div>

                <Components.ContactForm.EssentialDetails compact={true} />
            </div>
        );
    },
});

var RadioButtons = (props) => {
    return (
        null/*
        Warning: Unknown prop `group` on <input> tag. Remove this prop from the element. For details, see https://fb.me/react-unknown-prop

        <div className='guide-radioButtons'>
            <div className='guide-radioButtons-active'>
                <Forms.Radio label='One'   group='active' ident={1} />
                <Forms.Radio label='Two'   group='active' ident={2} />
                <Forms.Radio label='Three' group='active' ident={3} />
            </div>
            <div className='guide-radioButtons-inactive'>
                <Forms.Radio label='Four' group='inactive' ident={4} />
                <Forms.Radio label='Five' group='inactive' ident={5} />
                <Forms.Radio label='Six'  group='inactive' ident={6} />
            </div>
        </div>
        */
    );
};

const fontNameMapping = {
    '"Avenir Next Cyr W00 Ult Light"':  'Avenir Ultra Light',
    '"Avenir Next Cyr W00 Thin"':       'Avenir Thin',
    '"Avenir Next Cyr W00 Light"':      'Avenir Light',
    '"Avenir Next Cyr W00 Regular"':    'Avenir Regular',
    '"Avenir Next Cyr W00 Medium"':     'Avenir Medium',
    '"Avenir Next Cyr W00 Demi"':       'Avenir Demi',
    '"Avenir Next Cyr W00 Bold"':       'Avenir Bold',
    "ResoThin":                         'Reso Thin',
    "ResoLight":                        'Reso Light',
    "Reso":                             'Reso Regular',
    "ResoSemiBold":                     'Reso Semi',
    "ResoBold":                         'Reso Bold',
};


const FontPreview = React.createClass({
    getInitialState: function() {
        return {
            sample: 'A Quick Brown Fox Jumped Over The Lazy Dog',
            face: 'resoThin',
            size: 12,
            tracking: '',
            lineHeight: '1.15',
        };
    },
    _handleFaceChange(e) {
        this.setState({ face: e.target.value });
    },
    _handleSizeChange(e) {
        this.setState({size: e });
    },
    _handleTrackingChange(e) {
        this.setState({ tracking: e });
    },
    _handleLineHeightChange(e) {
        this.setState({ lineHeight: e });
    },
    _handleSampleChange(e) {
        this.setState({ sample: e.target.value });
    },
    render: function() {
        console.log(fontNameMapping[this.state.face]);
        return (
            <div className='guide-segment guide-fontpreview'>
                {/*
                <div className='form-field'>
                    <label htmlFor='face'>Face</label>
                    <div className='forms-control'>
                        <select name="face" onChange={this._handleFaceChange} value={this.state.face}>
                            {_.map(fontNameMapping, (face, name) => {
                                return (
                                    <option value={name} key={'face-' + face}>
                                        {name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                */}

                <div className='form-field'>
                    <label htmlFor='face'>Point size (pt) e.g. <i>12</i></label>
                    <div className='forms-control'>
                        <Forms.Input type='number' keyname='size' ref='size' action={this._handleSizeChange} />
                    </div>
                </div>

                <div className='form-field'>
                    <label htmlFor='tracking'>Tracking (em) e.g. <i>0.1</i></label>
                    <div className='forms-control'>
                        <Forms.Input type='number' keyname='tracking' ref='tracking' action={this._handleTrackingChange} />
                    </div>
                </div>

                <div className='form-field'>
                    <label htmlFor='lineHeight'>Line height (em) e.g. <i>1.15</i></label>
                    <div className='forms-control'>
                        <Forms.Input type='number' keyname='tracking' ref='lineHeight' action={this._handleLineHeightChange} />
                    </div>
                </div>

                <div className='form-field fontpreview-textarea'>
                    <label htmlFor='sample'></label>
                    <textarea name         = 'sample'
                              onChange     = {this._handleSampleChange}
                              defaultValue = {this.state.sample} />
                </div>

                <div className='fontpreview-preview'>
                    {_.map(fontNameMapping, (face, name) => {
                        return (
                            <div key={'preview-' + face} className='fontpreview-preview-sample' style={{
                                fontFamily: name,
                                fontSize: this.state.size + 'pt',
                                letterSpacing: this.state.tracking ? this.state.tracking + 'em' : 'inherit',
                                lineHeight: this.state.lineHeight,
                            }}>
                                <span dangerouslySetInnerHTML={{ __html:
                                    `${this.state.sample} @ ${this.state.size}pt ${face}`
                                }} />
                            </div>
                        );
                    })}
                    
                </div>
            </div>
        );
    },
});

var FontTest = (props) => {
    return (
        <div>
            {_.map([ 10, 12, 14, 20 ], function(pt) {
                return (
                    <span className={`type-${props.face}`} style={{ fontSize: pt + 'pt' }} key={pt}>
                        {`${props.face} ${pt}pt -`}
                    </span>
                );
            })}
        </div>
    );
};

var Fonts = (props) => {
    return (
        <div className='guide-segment guide-fonts'>
            <FontTest face='resoThin' />
            <FontTest face='resoLight' />
            <FontTest face='reso' />
            <FontTest face='resoSemiBold' />
            <FontTest face='resoBold' />

            <FontTest face='avenirUltraLight' />
            <FontTest face='avenirThin' />
            <FontTest face='avenirLight' />
            <FontTest face='avenir' />
            <FontTest face='avenirMedium' />
            <FontTest face='avenirDemi' />
            <FontTest face='avenirBold' />
        </div>
    );
};

var StyleGuideTest = React.createClass({
    _pxToPt(px) {
        // CSS standard 1pt = inch/72; browsers work in 96 DPI
        return (parseFloat(px) * 72 / 96);
    },
    getInitialState: function() {
        return {
            font: null,
        };
    },
    componentDidMount: function() {
        var styles = window.getComputedStyle(this.refs.test);
        var font = styles.fontFamily.match(/"(.*)"|([^,]*)/)[0];

        // Line height multiplier (default 1.15 by normalize.css)
        var lineHeightMult = (parseFloat(styles.lineHeight) / parseFloat(styles.fontSize)).toFixed(2);

        // Convert pixel letter-spacing to em (unless not specified in which case leave blank)
        var letterSpacingEm = styles.letterSpacing == 'normal' ? ''
                              : (parseFloat(styles.letterSpacing) / parseFloat(styles.fontSize)).toFixed(3).toString();
        if (letterSpacingEm.endsWith('0')) {
            letterSpacingEm = letterSpacingEm.substring(0, letterSpacingEm.length-1);
        }
        if (letterSpacingEm.length) {
            letterSpacingEm += 'em';
        }

        this.setState({
            // Map CSS font name to readable version
            font: fontNameMapping[font],

            // Convert font size from pixels to points
            size: this._pxToPt(styles.fontSize).toFixed() + 'pt',

            // Convert pixel letter-spacing to em (unless not specified in which case leave blank)
            letterSpacingEm: letterSpacingEm,

            // Blank if default line-height is 1.15, otherwise convert to points
            lineHeightPt: lineHeightMult == 1.15 ? '' : this._pxToPt(styles.lineHeight).toFixed() + 'pt',
        });
    },
    render: function() {
        var className = `guide-${this.props.style}`;
        return (
            <tr>
                <td>
                    {this.props.style}
                </td>
                <td>
                    {this.state.font}
                </td>
                <td>
                    {this.state.size}
                </td>
                <td>
                    {this.state.letterSpacingEm}
                </td>
                <td>
                    {this.state.lineHeightPt}
                </td>
                <td className={className} ref='test'>
                    A Quick Brown Fox Jumped Over The Lazy Dog.
                    {this.props.paragraph ?
                        <p>
                            Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,
                            totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae
                            dicta sunt explicabo.
                        </p>
                    : null}
                </td>
            </tr>
        );
    },
});

var StyleSheet = React.createClass({
    render: function() {
        return (
            <div className='guide-segment guide-styleguide'>
                <table>
                    <thead>
                        <tr>
                            <th>Style name</th>
                            <th>Font face</th>
                            <th>Font size</th>
                            <th>Letter spacing</th>
                            <th>Line height</th>
                            <th>Example</th>
                        </tr>
                    </thead>
                    <tbody>
                        <StyleGuideTest style='header-tier1nav' />
                        <StyleGuideTest style='header-tier2nav' />
                        <StyleGuideTest style='cat-headers' />
                        <StyleGuideTest style='footer-header' />
                        <StyleGuideTest style='footer-body' paragraph={true} />
                        <StyleGuideTest style='h1' />
                        <StyleGuideTest style='h1-rev' />
                        <StyleGuideTest style='h2' />
                        <StyleGuideTest style='sh1' />
                        <StyleGuideTest style='nav1' />
                        <StyleGuideTest style='nav2' />
                        <StyleGuideTest style='breadcrumb' />
                        <StyleGuideTest style='bodycopy1' paragraph={true} />
                        <StyleGuideTest style='bodycopy2' paragraph={true} />
                        <StyleGuideTest style='bodycopy3' paragraph={true} />
                        <StyleGuideTest style='tabs' />
                        <StyleGuideTest style='radio-label' />
                        <StyleGuideTest style='byo-matrix-label' />
                        <StyleGuideTest style='byo-matrix-value' />
                        <StyleGuideTest style='textfield' />
                    </tbody>
                </table>
            </div>
        );
    },
});

var StyleGuide = (props) => {
    return (
        <div className='guide'>
            {/*
            <ResponsiveIdentification />
            <ResponsiveImages />
            <RadioButtons />
            */}
            <BrandColors />
            <Buttons />
            {/*
            <FormsTest />
            */}
            <FontPreview />
            {/*
            <Fonts />
            */}
            <StyleSheet />
        </div>
    );
}

module.exports = StyleGuide;



// WEBPACK FOOTER //
// ./src/pages/internal/style-guide.jsx